<template>
  <div class="home-iframe-wrap" ref="wrap">
    <headerView v-if="headerStatus"></headerView>
    <iframe v-if="iframeSrc" ref="frame" :src="iframeSrc" @load="onLoad" frameborder="0" />
    <!--   scrolling="no" -->
    <!-- iframe 里面的头部 css BaseLayout.cL8HcRQ1控制直接隐藏 -->

    <!-- <footView ref="footView" :showType="2"></footView> -->
    <div class="footTop" style="display: none;">
      <div class="rowCenter download-section" >
        <div class="download-name download-name_left">
          <p class="text-3xl p1" style="font-weight: 700;">{{ footData.downloadTitle }}</p>
          <p class="text-base p2">{{ footData.downloadDescribe }}</p>
        </div>
        <div class="download-image" v-if="footData.downloadImgUrl">
          <img class="img" :src="footData.downloadImgUrl" />
        </div>
        <div class="">
          <div class="download-name download-name_right">
            <p class="text-3xl p1">{{ footData.downloadTitle }}</p>
            <p class="text-base p2">{{ footData.downloadDescribe }}</p>
          </div>
          <div class="rowCenter download-code">
            <div class="center grid mr-40" v-if="footData.downloadCodeUrl1">
              <div class="imgbox">
                <img class="img" :src="footData.downloadCodeUrl1" />
              </div>
              <p class="text-sm mgb15">{{ footData.downloadCodeName1 }}</p>
            </div>
            <div class="center grid" v-if="footData.downloadCodeUrl2">
              <div class="imgbox">
                <img class="img" :src="footData.downloadCodeUrl2" />
              </div>
              <p class="text-sm mgb15">{{ footData.downloadCodeName2 }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footView ref="footView" style="display: none;"></footView>


  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'HomeIframeWrapper',
  props: {
    iframePath: { type: String, default: '' }
  },
  data() {
    return {
      headerStatus: false,
      iframeSrc: '',
      $ro: null,
      $frameLoadHandler: null,
      $fitTimer: null,
      $lastFitHeight: 0,
      $fitGuardUntil: 0,
      $footInjectTimer: null
    }
  },
  computed: {
    ...mapGetters({ footData: 'footData', configData: 'configData' }),
    metaPath() {
      return this.$route.meta.iframePath || this.iframePath || ''
    },
    hasFootData() {
      return this.footData && (this.footData.footNav || this.footData.footOfficial)
    }
  },
  watch: {
    metaPath: {
      immediate: true,
      handler(v) {
        this.iframeSrc = v || ''
      }
    },
    hasFootData: {
      immediate: true,
      handler(v) {
        if (!v) return
        if (this.$footInjectTimer) clearTimeout(this.$footInjectTimer)
        this.$footInjectTimer = setTimeout(() => {
          this.$footInjectTimer = null
          this.injectFootToIframe()
        }, 100)
      }
    }
  },
  mounted() {
    window.addEventListener('message', this.onMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onMessage)
    if (this.$footInjectTimer) {
      clearTimeout(this.$footInjectTimer)
      this.$footInjectTimer = null
    }
    if (this.$ro) {
      this.$ro.disconnect()
      this.$ro = null
    }
    const f = this.$refs.frame
    if (f && this.$frameLoadHandler) {
      f.removeEventListener('load', this.$frameLoadHandler)
      this.$frameLoadHandler = null
    }
  },
  methods: {
    onLoad() {
      this.$nextTick(() => {
        this.injectBridge()
        this.injectFootToIframe()
        setTimeout(() => {
          this.fitHeight()
          this.observeHeight()
        }, 1500)


        const iframeElement = this.$refs.frame;
        const iframeDoc = iframeElement.contentDocument || iframeElement.contentWindow.document;
        this.headerStatus = iframeDoc.querySelector('.site-header .nav-row') ? true : false;


      })
    },
    injectFootToIframe() {
     
      const f = this.$refs.frame
      if (!f || !f.contentDocument) return
      const footEl = this.$refs.footView && this.$refs.footView.$el
      if (!footEl) return

      const doc = f.contentDocument

      const mini_program= doc.querySelector('.mini-program-section');
      if(mini_program){
        let footTop_html=document.querySelector(".footTop").innerHTML;
         mini_program.innerHTML = footTop_html||"";
      }

      const footer = doc.querySelector('.site-footer')
      if (!footer) return
      const html = footEl.querySelector(".foot-content").outerHTML;
      if (!html || html === footer.innerHTML) return
      footer.innerHTML = html
      footer.style.display = 'block';
      footer.style.paddingTop = 0;
      const root = footer.firstElementChild

      if (root && !root.classList.contains('__foot-injected__')) {
        root.classList.add('__foot-injected__')
      }
    },
    fitHeight() {
      const self = this
      if (self.$fitTimer) return
      const now = Date.now()
      if (now < self.$fitGuardUntil) {
        self.$fitTimer = setTimeout(() => {
          self.$fitTimer = null
          self.fitHeight()
        }, self.$fitGuardUntil - now + 20)
        return
      }
      self.$fitTimer = setTimeout(() => {
        self.$fitTimer = null
        try {
          const f = self.$refs.frame
          if (!f || !f.contentDocument) return
          const doc = f.contentDocument
          const body = doc.body
          const html = doc.documentElement
          if (!body || !html) return
          let h = Math.max(body.scrollHeight, html.scrollHeight, body.offsetHeight, html.offsetHeight)
          if (!h) return
          if (h > 50000) {
            h = self.$lastFitHeight || 800
            self.$fitGuardUntil = Date.now() + 1000
          }
          if (Math.abs(h - self.$lastFitHeight) < 2) return
          self.$lastFitHeight = h
          // f.style.height = h + 'px';//8899  注释首页显示内容正常
          self.$fitGuardUntil = Date.now() + 80
        } catch (e) {
          self.$fitGuardUntil = Date.now() + 200
        }
      }, 50)
    },
    observeHeight() {
      const f = this.$refs.frame
      if (!f || !f.contentDocument || typeof ResizeObserver === 'undefined') return
      if (this.$ro) this.$ro.disconnect()
      const self = this
      this.$ro = new ResizeObserver(() => self.fitHeight())
      const doc = f.contentDocument
      if (doc.body) this.$ro.observe(doc.body)
      if (doc.documentElement) this.$ro.observe(doc.documentElement)
    },
    injectBridge() {
      const f = this.$refs.frame
      if (!f) return
      const doc = f.contentDocument
      const win = f.contentWindow
      if (!doc || !win) return
      this.injectBaseHref(doc)
      doc.addEventListener('click', this._onFrameClick, true)
      win.addEventListener('popstate', this._onFramePop)
    },
    injectScrollTriggersOverride(win) {
      if (!win || win.__homeWrapperRoDisabled) return
      win.__homeWrapperRoDisabled = true
      const FakeRO = function () { }
      FakeRO.prototype.observe = function () { }
      FakeRO.prototype.unobserve = function () { }
      FakeRO.prototype.disconnect = function () { }
      win.ResizeObserver = FakeRO
    },
    injectBaseHref(doc) {
      if (!doc) return
      if (doc.querySelector('base[data-home-wrapper]')) return
      const base = doc.createElement('base')
      base.setAttribute('data-home-wrapper', '1')
      base.setAttribute('href', '/webStatic/home/')
      const head = doc.head || doc.documentElement
      if (head.firstChild) {
        head.insertBefore(base, head.firstChild)
      } else {
        head.appendChild(base)
      }
    },
    _onFrameClick(e) {
      const f = this.$refs.frame
      if (!f) return
      const win = f.contentWindow
      const a = e.target && e.target.closest && e.target.closest('a[href]')
      if (!a) return
      if (a.target === '_blank') return
      const href = a.getAttribute('href')
      if (!href) return
      if (href.startsWith('#')) return
      if (/^(mailto|tel|javascript):/i.test(href)) return
      let abs = ''
      try { abs = new URL(href, win.location.href).href } catch (err) { return }
      if (/^https?:\/\//i.test(abs) && win && !abs.startsWith(win.location.origin)) return
      e.preventDefault()
      e.stopPropagation()
      const path = this._toHomePath(abs, win)
      if (!path) return
      window.parent.postMessage({ type: 'home-navigate', path }, '*')
    },
    _onFramePop() {
      const f = this.$refs.frame
      if (!f || !f.contentWindow) return
      const path = this._toHomePath(f.contentWindow.location.pathname, f.contentWindow)
      if (!path) return
      window.parent.postMessage({ type: 'home-pop', path }, '*')
    },
    _toHomePath(raw, win) {
      if (!raw) return ''
      let p = String(raw)
      const origin = win && win.location ? win.location.origin : ''
      if (origin && p.startsWith(origin)) p = p.slice(origin.length)
      if (p.startsWith('/webStatic/home/')) p = p.slice('/webStatic/home'.length)
      else if (p === '/webStatic/home' || p === '/webStatic/home/') p = '/'
      const hashIdx = p.indexOf('#')
      const hash = hashIdx >= 0 ? p.slice(hashIdx) : ''
      let path = hashIdx >= 0 ? p.slice(0, hashIdx) : p
      path = path.replace(/\/index\.html$/, '/')
      if (!path || path === '/') {
        path = '/home'
      } else if (path.startsWith('/store') || path.startsWith('/category') || path.startsWith('/goods') || path.startsWith('/article') || path.startsWith('/culture') || path.startsWith('/page') || path.startsWith('/warranty') || path.startsWith('/message')) {
        //path=path;
      } else if (!path.startsWith('/home')) path = '/home' + path
      if (!path.endsWith('/')) path = path + '/'
      return path + hash

      // if (!raw) return ''
      // let p = String(raw)
      // const origin = win && win.location ? win.location.origin : ''
      // if (origin && p.startsWith(origin)) p = p.slice(origin.length)
      // if (p.startsWith('/webStatic/home/')) p = p.slice('/webStatic/home'.length)
      // else if (p === '/webStatic/home' || p === '/webStatic/home/') p = '/'
      // const hashIdx = p.indexOf('#')
      // const hash = hashIdx >= 0 ? p.slice(hashIdx) : ''
      // let path = hashIdx >= 0 ? p.slice(0, hashIdx) : p
      // path = path.replace(/\/index\.html$/, '/')
      // if (!path) path = '/'
      // if (!path.endsWith('/')) path = path + '/'
      // return path + hash
    },
    onMessage(e) {
      const d = e.data || {}
      if (!d || typeof d !== 'object') return
      if (d.type === 'home-navigate' && d.path) {
        this.$router.push(d.path).catch(() => { })
      } else if (d.type === 'home-pop' && d.path) {
        this.$router.push(d.path).catch(() => { })
      }
    }
  }
}
</script>

<style scoped>
.home-iframe-wrap {
  width: 100%;
}

.home-iframe-wrap iframe {
  display: block;
  width: 100%;
  height: 100vh;
  border: 0;
}
</style>
